<template>
  <div class="uploader-box">
    <uploader
      v-if="isOpenProcess"
      :options="options"
      class="uploader-example"
      @file-added="onFileAdded"
      @file-success="onFileSuccess"
      @file-error="onFileError"
      @complete="onComplete"
      :fileStatusText="filsStatusText"
      ref="uploader"
    >
      <!-- <uploader-unsupport></uploader-unsupport> -->
      <!-- <uploader-drop>
    </uploader-drop> -->
      <div class="d-flex btn-box">
        <uploader-btn>{{ uploadText }}</uploader-btn>
        <!-- <el-button type="primary">上传文件</el-button> -->
        <!-- <uploader-btn :directory="true">上传文件夹</uploader-btn> -->
      </div>
      <!-- <uploader-list>
        <div class="file-panel" slot-scope="props">
          <div class="uploadProgress-title" v-if="props.fileList.length">
            <span class="fz-14">上传进度</span>
            <div>
              <i
                v-if="!isExpended"
                class="iconfont icon-top fz-16 cur-pointer m-l-5"
                @click="openUploadProgress"
              ></i>
              <i
                v-if="isExpended"
                class="iconfont icon-bottom fz-16 cur-pointer m-l-5"
                @click="shrinkUploadProgress"
              ></i>
              <i
                class="iconfont icon-close fz-16 cur-pointer m-l-5"
                @click="closeUploadProgress"
              ></i>
            </div>
          </div>
          <ul class="file-list" v-if="isExpended">
            <li v-for="file in props.fileList" :key="file.id">
              <uploader-file
                :class="'file_' + file.id"
                ref="files"
                :file="file"
                :list="true"
              ></uploader-file>
            </li>
          </ul>
        </div>
      </uploader-list> -->
    </uploader>
    <el-button v-else size="small" type="primary" class="default-btn">上传文件</el-button>
  </div>
</template>

<script>
import Vue from 'vue'
import SparkMD5 from 'spark-md5'
import { FileApi } from '@wiz-api/file-management'
import uploader from 'vue-simple-uploader'

Vue.use(uploader)
const fileApi = new FileApi()

/* eslint-disable */

export default {
  name: 'uploadFile',
  props: {
    uploadText: {
      type: String,
      default: '上传文件',
    },
    FolderId: {
      type: String,
      default: '',
    },
    fileMaxsize: {
      type: Number,
      default: 2, // 单位 M
    },
    fileAccept: {
      type: String,
      default: '',
    },
    // 上传类型 1 = 附件；2 = 视频
    filetype: {
      type: Number,
      default: 1,
    },
    // 单个文件上传
    singleFile: {
      type: Boolean,
      default: false,
    },
    // 文件上传数量
    maxFileCount: {
      type: Number || null,
      default: null,
    },
    // 文件列表
    fileList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    const _this = this
    return {
      fileInfo: null, // 合并后的文件信息
      // 用于替换组件原来的状态显示文字
      filsStatusText: {
        success: '成功',
        error: '失败',
        uploading: '上传中',
        paused: '暂停',
        waiting: '等待中',
      },
      isOpenProcess: true, // 上传进度条弹框状况
      isExpended: true, // 上传进度弹框是否展开
      // uploader 的主要配置
      options: {
        singleFile: this.singleFile, // 是否单文件上传
        chunkSize: 2 * 1024 * 1024, // 允许片段最大为2M，因为最后一块默认是可以大于等于这个值，但必须小于它的两倍。
        simultaneousUploads: 3, // 最大并发上传数
        uploadMethod: 'POST',
        testMethod: 'POST',
        forceChunkSize: true, // 是否强制所有的块都是小于等于chunkSize的值，默认为false
        headers: {
          Authorization: '',
        },
        testChunks: false,
        target: (val) => {
          return `${this.fileManagement}/api/file-management/files/chunk-upload/${val.uniqueIdentifer}/${val.chunkIndex}`
        }, // 目标上传 URL，若测试和上传接口不是同个路径，可以用函数模式
        permanentErrors: [404, 415, 500, 501, 413, 409, 403], //需进入错误回调函数中提示错误信息
        // 每次发起测试校验，所有分片都会进入这个回调
        checkChunkUploadedByResponse: function(chunk, message) {
          // 每次校验，chunk（片段）会不一样，但message（只有一个测试请求）一样
          let objMessage = JSON.parse(message)
          // 后端认为这个文件上传过，则直接跳过
          if (objMessage.skipUpload) return true

          // 若文件检测出现异常，则提示并返回false
          if (objMessage.error) {
            _this.$message.error(objMessage.message)
            return false
          }
          // 一些校验信息，需要用到的，可以绑定在chunk上
          chunk.xxx = objMessage.xxx // 可写可不写，看自己情况

          // chunk的offset就是分块后，该块片段在文件所有模块的位置
          return (objMessage.uploadedList || []).indexOf(chunk.offset + 1) >= 0
        },
        // 处理所有请求的参数
        processParams: async (params, file, chunk) => {
          if (params.chunkNumber === 1) {
            file.chunkIndex = file.chunkInitIndex
          } else {
            file.chunkIndex++
          }
          // file.chunkIndex = params.chunkNumber
          return params
        },
      },
    }
  },
  beforeCreate() {
    // LocalForage.getItem('fullToken').then((token) => {
    //   this.options.headers.Authorization = token
    // })
  },
  computed: {
    fileManagement() {
      const endpoints = Wiz.globalSettings?.api?.endpoints
      const defaultApi = endpoints ? endpoints.default : ''
      const fileApiModuleName = Wiz.globalSettings?.api?.modules['file-management']
      const fileDomain = endpoints ? endpoints[fileApiModuleName] : ''
      return fileDomain ? fileDomain : defaultApi
    },
  },
  methods: {
    fileRemove(index) {
      this.$refs.uploader.fileList.splice(index, 1)
      this.$refs.uploader.files.splice(index, 1)
    },
    onComplete() {},
    // 最小化弹框
    shrinkUploadProgress() {
      this.isExpended = false
    },
    // 最大化弹框
    openUploadProgress() {
      this.isExpended = true
    },
    // 关闭弹框操作
    closeUploadProgress(fileList) {
      this.isOpenProcess = false
      setTimeout(() => {
        this.isOpenProcess = true
        this.isExpended = true
      }, 10)
      // 刷新页面
    },
    // 导入文件时
    onFileAdded(file) {
      if (this.maxFileCount && this.fileList?.length >= this.maxFileCount) {
        this.$message.warning(`最多只能上传${this.maxFileCount}个文件`)
        file.pause()
        file.cancel()
        return false
      }
      const fileFormat = this.fileAccept.split(',').includes(
        file.name
          .split('.')
          .at(-1)
          .toLowerCase()
      )
      // 附件不限制文件格式
      if (!fileFormat && this.filetype !== 1) {
        this.$message.warning(`请上传指定格式的文件，${this.fileAccept}`)
        file.pause()
        file.cancel()
        return false
      }

      const isGreatThenMaxsize = file.size / 1024 / 1024 > this.fileMaxsize
      if (isGreatThenMaxsize) {
        this.$message.error(`文件大小超过限制，最大为${this.fileMaxsize}M`)
        file.pause()
        file.cancel()
        return false
      }
      // 计算文件 MD5 并标记文件
      this.computeMD5(file)
      return true
    },
    // 上传失败
    onFileError(rootFile, file, res) {
      this.$message.error(JSON.parse(res).error)
    },
    // 取消文件上传
    onFileRemoved(file) {
      // 发起取消上传请求给后端
      //   this.$axios.cancelUploadFile({
      //     filename: file.name,
      //     identifier: file.uniqueIdentifer, // 文件标记
      //   })
    },
    // 所有片段上传成功后，进入文件上传成功回调
    async onFileSuccess(rootFile, file, res) {
      // 后端返回成功的字段，插件认为只要所有片段的上传请求都成功了就是上传成功了，而对于其他的错误它是无法处理的
      // 如果后端返回可以合并的字段则发起合并请求
      if (res) {
        const [err, res] = await fileApi.mergeFiles({
          body: {
            md5: file.uniqueIdentifer,
            fileName: file.name,
            folderId: '00000000-0000-0000-0000-000000000000',
            authLevel: 2,
          },
        })
        if (!err) {
          this.fileInfo = res[0]
          this.$emit('filesUploadComplete', this.fileInfo)
        } else {
          this.$emit('on-error')
        }

        // // 获取组件的成功状态显示dom节点
        // const metaDom = document.querySelector(
        //   `.uploader-file.file_${file.id} .uploader-file-status`
        // )
        // // 是上传的文件
        // if (metaDom) {
        //   // 因为插件在所有片段请求成功后就显示上传成功的状态
        //   // 可合并是否成功却不管了，而插件并未提供处理方式
        //   // 只能通过节点操作修改状态来处理了
        //   metaDom.innerText = '合并中...'
        //   // axios.mergeChunk({...}); // 发起合并请求
        //   const [err] = await fileApi.mergeFiles({
        //     body: {
        //       md5: file.uniqueIdentifer,
        //       fileName: file.name,
        //       FolderId: this.FolderId,
        //     }
        //   })
        //   if (!err) {
        //     metaDom.innerText = '成功'
        //   } else {
        //     metaDom.innerText = '成功(合并失败)'
        //   }
        // } else {
        //   // 上传的文件夹
        //   const res = await fileApi.mergeFiles({
        //     body: {
        //       md5: file.uniqueIdentifer,
        //       fileName: file.name,
        //       FolderId: this.FolderId,
        //     }
        //   })
        // }
      } else {
        // 分片上传成功，但整个文件上传并未结束，不需要合并
      }
    },
    // 根据文件内容计算 MD5 并标记文件 file
    computeMD5(file) {
      let fileReader = new FileReader()
      let time = new Date().getTime()
      let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
      let currentChunk = 0
      const chunkSize = this.options.chunkSize
      let chunks = Math.ceil(file.size / chunkSize) // 总模块数
      let spark = new SparkMD5.ArrayBuffer()

      // 文件状态设为"计算MD5"
      //   this.statusSet(file.id, 'md5')

      file.pause() // 先暂停文件的上传过程

      loadNext() // 开始读取文件内容

      // FileReader 加载完成
      fileReader.onload = (e) => {
        // 插入读取的片段内容到 SparkMD5 中
        spark.append(e.target.result)

        // 按分片顺序读取，小于最后模块位置的就继续读取
        if (currentChunk < chunks) {
          currentChunk++

          const md5Progress = ((currentChunk / chunks) * 100).toFixed(0)
          if (md5Progress <= 100) {
            const num = md5Progress * 1 === 100 ? 99 : md5Progress
            this.$emit('on-progress', num)
            // dom.innerText = 'MD5校验：' + md5Progress + '%'
          }
          // 实时展示MD5的计算进度
          // 对于大型文件读取内容还是会花不少时间
          // 所以需要显示读取进度在界面
          // let dom = document.querySelector(`.uploader-file.file_${file.id} .uploader-file-meta`) || true
          // if (dom) {
          //   let md5Progress = ((currentChunk / chunks) * 100).toFixed(0)
          //   if (md5Progress < 100) {
          //     this.$emit('on-progress', md5Progress)
          //     // dom.innerText = 'MD5校验：' + md5Progress + '%'
          //   } else if (md5Progress === 100) {
          //     // dom.innerText = 'MD5校验完成'
          //   }
          // }
          loadNext()
        } else {
          // 所有文件分片内容读取完成，生成MD5
          let md5 = spark.end()
          // 在computeMD5Success中标记文件
          this.computeMD5Success(md5, file)
        }
      }
      // FileReader 加载失败
      fileReader.onerror = function() {
        this.error(`文件${file.name}读取出错，请检查该文件`)
        file.cancel()
      }

      // 分片读取文件内容函数
      function loadNext() {
        let start = currentChunk * chunkSize
        let end = start + chunkSize >= file.size ? file.size : start + chunkSize
        // fileReader 读取文件
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end))
      }
    },
    statusSet(id, status) {
      let statusMap = {
        md5: {
          text: '校验MD5',
          bgc: '#fff',
        },
        merging: {
          text: '合并中',
          bgc: '#e2eeff',
        },
        transcoding: {
          text: '转码中',
          bgc: '#e2eeff',
        },
        failed: {
          text: '上传失败',
          bgc: '#e2eeff',
        },
      }

      this.$nextTick(() => {
        // $(`<p class="myStatus_${id}"></p>`).appendTo(`.file_${id} .uploader-file-status`).css({
        $(`<p class="myStatus_${id}"></p>`)
          .appendTo(`#status`)
          .css({
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            zIndex: '1',
            'line-height': 'initial',
            backgroundColor: statusMap[status].bgc,
          })
          .text(statusMap[status].text)
      })
    },
    async computeMD5Success(md5, file) {
      file.uniqueIdentifer = md5 // 标记文件file
      // 通过md5获取当前文件的切片号
      const [err, res] = await fileApi.getMaxChunk(file.uniqueIdentifer)
      if (!err) {
        if (res >= 0) {
          file.chunkInitIndex = res
        } else {
          file.chunkInitIndex = 0
        }
      }
      file.resume() // 继续上传
    },
  },
}
</script>

<style lang="scss">
.uploader-box {
  // position: absolute;
  // left: 386px;
  // top: 30px;
  // background: rgb(228, 227, 227);
  // z-index: 80;
  // border: 1px solid #999;
}
.btn-box {
  // width: 71px !important;
  flex-direction: column;
}
.uploader-example {
  position: absolute;
  top: 0px;
  left: 0px;
  font-size: 12px;
}
.default-btn {
  position: absolute;
  top: 0px;
  left: 0px;
}
.uploadProgress-title {
  padding: 5px;
  border-bottom: 1px solid #bbb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
}
.uploader-example .uploader-btn {
  width: fit-content;
  background-color: var(--buttonPrimaryBg) !important;
  color: var(--colorLumpText) !important;
  border-color: var(--buttonPrimarySelect);
  height: 36px;
  line-height: 36px;
  font-size: 14px !important;
  border-radius: 4px;
  padding: 0 15px;
  white-space: nowrap;
  cursor: pointer;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  &:hover,
  &:focus {
    background-color: var(--buttonPrimarySelect) !important;
    border-color: var(--buttonPrimarySelect) !important;
    color: var(--colorLumpText) !important;
  }
}
.uploader-example .uploader-list .file-list {
  max-height: 200px !important;
  overflow-y: auto !important;
}
.uploader-list {
  position: fixed !important;
  bottom: 14px;
  right: 12px;
  background: #f5f7fa;
  z-index: 99;
  box-shadow: 0px 0px 5px 1px rgb(183, 185, 187);
  border-radius: 2px;
  width: 530px;
}
::v-deep .uploader-box {
  left: 5px !important;
  top: 5px !important;
}
</style>
